const methodologySteps = [
  'Intake and validate the request.',
  'Decompose outcomes before implementation.',
  'Run verification before convergence.',
];

export function MethodologyPanel(): React.ReactElement {
  return (
    <div className="space-y-2">
      <div className="text-[11px] font-semibold uppercase tracking-wider text-text-tertiary">
        Methodology
      </div>
      <div className="space-y-2 text-[11px] leading-5 text-text-secondary">
        {methodologySteps.map(step => (
          <div
            key={step}
            className="rounded-md border border-border/60 bg-surface-elevated/40 px-2 py-1.5"
          >
            {step}
          </div>
        ))}
      </div>
    </div>
  );
}
